package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_03_22_Day_1
import com.veldekar.components.logs.Log_2025_03_22_Day_2
import com.veldekar.components.logs.Log_2025_03_22_Day_3
import com.veldekar.components.logs.Log_2025_03_22_Day_4
import com.veldekar.components.logs.Log_2025_03_22_Day_5
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-03-22")
@Composable
public fun Log_2025_03_22(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "#FriendsOfTheForest",
        ogTitle = "#FriendsOfTheForest",
        date = LocalDate(2_025, 3, 22),
        aiHint = "Description is a joke",
        ogDescription = "Dress like nobody’s watching; love like you’ve never been hurt. Perform music like nobody’s listening; live as a friend of the forest.",
        ogImage = "ai/2025-03-22.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-79", dateString = "Newgrowth 79")
        Log_2025_03_22_Day_1()
        SessionDayHeader(dayId = "newgrowth-80", dateString = "Newgrowth 80")
        Log_2025_03_22_Day_2()
        SessionDayHeader(dayId = "newgrowth-81", dateString = "Newgrowth 81")
        Log_2025_03_22_Day_3()
        SessionDayHeader(dayId = "newgrowth-82", dateString = "Newgrowth 82")
        Log_2025_03_22_Day_4()
        SessionDayHeader(dayId = "newgrowth-83", dateString = "Newgrowth 83")
        Log_2025_03_22_Day_5()
    }
}
